// extracted by mini-css-extract-plugin
export default {"wrapper-label":"field-label_wrapper-label__Ep0OG","label":"field-label_label__uci-0"};